import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.6105 8.55646L15.4435 11.3895L8.83306 18H6V15.1669L12.6105 8.55646ZM13.5548 7.61211L14.9713 6.19558C15.2322 5.93481 15.6549 5.93481 15.9157 6.19558L17.8044 8.08429C18.0652 8.34506 18.0652 8.76786 17.8044 9.02863L16.3878 10.4452L13.5548 7.61211Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { EditFilledIcon };
